import { UpdateTicketPayload } from './useUpdateTicket.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import zendeskGateway from 'services/help-center/zendeskBackendGateway';
import {
    Ticket,
    Audit,
} from 'modules/IMC/MessageCenter/components/MessageCenterContent/MessageList/MessageList.interface';

const updateTicket = async (ticketId: number, payload: UpdateTicketPayload) => {
    try {
        const responseData = await zendeskGateway.put<{ audit: Audit; ticket: Ticket }>(
            `/tickets/${ticketId}`,
            payload
        );
        return responseData?.data;
    } catch (error) {
        sendDatadogRumError('updateTicket', error, { source: 'updateTicket', ticketId, payload });
        throw error;
    }
};

export default updateTicket;
